import React from "react";
import "../SubscriptionPaymentItem/style.scss";
import { CircularProgress } from "@mui/material";
import Localized from "../../Localized";

const PaymentItem = ({ item, onClick }) => {
    return (
        <div
            className="subscription-payment-item"
            onClick={() => onClick(item)}>
            <span
                className={`subscription-payment-item_info ${
                    item.status == "success"
                        ? "success"
                        : "warning"
                }`}>
                {item.amount} {item.currency}{" "}
                {Localized[item.status] || item.status}
            </span>

            <span className="subscription-payment-item_date">
                {new Date(
                    item.created_at
                ).toLocaleString("ru-RU", {
                    day: "2-digit",
                    month: "short",
                    hour: "2-digit",
                    minute: "2-digit",
                })}
            </span>
        </div>
    );
};

export default PaymentItem;
